import axios from 'axios'

export const genericDelete = (id: string | null | undefined, type: 'narrative' | 'community' | 'tag') => {
  return axios.delete(`/${type}/${id}`)
}
